export interface Topic {
  id: string;
  title: string;
  subtitle: string;
  intro: string;
  reason: string;
  groups: { name: string; filmIds: string[] }[];
  relatedIds: string[];
}

export const topics: Topic[] = [
  {
    id: "classic-restored",
    title: "经典修复系列",
    subtitle: "被时间洗过的光",
    intro:
      "我们从胶片库里重新找回这些作品，以 4K 扫描与逐帧修复还原它们最初的光线、颗粒与呼吸感。它们不是怀旧，而是让今天的观众重新看见一个时代的表情。",
    reason:
      "这组影片代表日本电影在家庭叙事与人物刻画上的高峰，修复版保留了原始胶片的柔和层次，适合在大屏幕与安静的环境里慢慢观看。",
    groups: [
      { name: "主单元 · 修复重映", filmIds: ["yinghua-canying", "liulang-de-qishou", "lutu-de-zhongdian"] },
      { name: "延展单元 · 同代佳作", filmIds: ["jingdu-siji", "shanjian-xiaodiao", "xueguo-laixin"] },
    ],
    relatedIds: ["year-2024", "kyoto-poetry", "healing-daily"],
  },
  {
    id: "year-2024",
    title: "2024 年度精选",
    subtitle: "今年值得被记住的九个瞬间",
    intro:
      "从雪夜列车到剧场谢幕，2024 年的日本电影在类型与作者表达之间找到了新的平衡。这份片单记录了我们在这一年里最想推荐给你的作品。",
    reason:
      "片单兼顾口碑与讨论度，涵盖悬疑、剧情、爱情与音乐类型，适合作为了解本年度日本电影的入口。",
    groups: [
      { name: "主单元 · 年度之选", filmIds: ["yekou-lieche", "zuihou-de-wutai", "dongjing-canxiang", "chunri-de-ni"] },
      { name: "延展单元 · 遗珠推荐", filmIds: ["yuzhong-de-yueding", "dongri-huayuan"] },
    ],
    relatedIds: ["classic-restored", "mystery-files", "kyoto-poetry"],
  },
  {
    id: "mystery-files",
    title: "悬疑推理特辑",
    subtitle: "真相藏在沉默里",
    intro:
      "一列停摆的列车、一段来自深海的录音、一份没有证词的案件。这些作品把谜题放在人物心里，而不是放在最后五分钟的反转里。",
    reason:
      "如果你偏爱慢热的推理与心理张力，这一组影片提供了一个完整的悬疑光谱：从密室到法庭，从城市到海边。",
    groups: [
      { name: "主单元 · 密室与证词", filmIds: ["wusheng-de-zhengren", "yekou-lieche", "yongye-de-bianjibu"] },
      { name: "延展单元 · 心理暗流", filmIds: ["shenhai-huisheng", "beihai-de-shouhuren", "poxiao-zhiqian"] },
    ],
    relatedIds: ["year-2024", "classic-restored", "healing-daily"],
  },
  {
    id: "kyoto-poetry",
    title: "京都映像诗",
    subtitle: "一座城市的四季语法",
    intro:
      "町屋的木格窗、鸭川边的风、和果子铺里升起的蒸汽。京都从来不只是背景，它本身就是这些电影里的一个角色。",
    reason:
      "这一组以空间与季节为线索，适合喜欢生活流叙事与细腻影像质感的观众。",
    groups: [
      { name: "主单元 · 四季流转", filmIds: ["jingdu-siji", "huayuan-de-zhongbiao", "dongri-huayuan"] },
      { name: "延展单元 · 城市侧写", filmIds: ["haibian-de-jiushudian", "chunri-de-ni"] },
    ],
    relatedIds: ["healing-daily", "classic-restored", "year-2024"],
  },
  {
    id: "healing-daily",
    title: "治愈系日常",
    subtitle: "把日子过成一条缓慢的河",
    intro:
      "没有戏剧性的转折，只有一顿饭、一场雨、一次久别重逢。这些作品相信，生活的重量往往藏在最轻的地方。",
    reason:
      "适合疲惫的时候打开。节奏舒缓、画面干净，看完之后会更愿意好好吃一顿饭。",
    groups: [
      { name: "主单元 · 缓慢生活", filmIds: ["haibian-de-jiushudian", "shanjian-xiaodiao", "jingdu-siji"] },
      { name: "延展单元 · 温柔相遇", filmIds: ["dongri-huayuan", "huayuan-de-zhongbiao"] },
    ],
    relatedIds: ["kyoto-poetry", "classic-restored", "mystery-files"],
  },
];